import Picture1 from "@/assets/profilePictures/pp-1.webp";
import Picture2 from "@/assets/profilePictures/pp-2.webp";
import Picture3 from "@/assets/profilePictures/pp-3.webp";
import Picture4 from "@/assets/profilePictures/pp-4.webp";
import Picture5 from "@/assets/profilePictures/pp-5.webp";
import Picture6 from "@/assets/profilePictures/pp-6.webp";
import Picture7 from "@/assets/profilePictures/pp-7.webp";
import Picture8 from "@/assets/profilePictures/pp-8.webp";
import Picture9 from "@/assets/profilePictures/pp-9.webp";
import Picture10 from "@/assets/profilePictures/pp-10.webp";
import Picture11 from "@/assets/profilePictures/pp-11.webp";
import Picture12 from "@/assets/profilePictures/pp-12.webp";
import Picture13 from "@/assets/profilePictures/pp-13.webp";
import Picture14 from "@/assets/profilePictures/pp-14.webp";
import Picture15 from "@/assets/profilePictures/pp-15.webp";
import Picture16 from "@/assets/profilePictures/pp-16.webp";
import Picture17 from "@/assets/profilePictures/pp-17.webp";
import Picture18 from "@/assets/profilePictures/pp-18.webp";
import Picture19 from "@/assets/profilePictures/pp-19.webp";
import Picture20 from "@/assets/profilePictures/pp-20.webp";
import Picture21 from "@/assets/profilePictures/pp-21.webp";
import Picture22 from "@/assets/profilePictures/pp-22.webp";
import Picture23 from "@/assets/profilePictures/pp-23.webp";
import Picture24 from "@/assets/profilePictures/pp-24.webp";
import Picture25 from "@/assets/profilePictures/pp-25.webp";

import Picture51 from "@/assets/profilePictures/pp-26.webp";
import Picture52 from "@/assets/profilePictures/pp-27.webp";
import Picture53 from "@/assets/profilePictures/pp-28.webp";
import Picture54 from "@/assets/profilePictures/pp-29.webp";
import Picture55 from "@/assets/profilePictures/pp-30.webp";
import Picture56 from "@/assets/profilePictures/pp-31.webp";
import Picture57 from "@/assets/profilePictures/pp-32.webp";
import Picture58 from "@/assets/profilePictures/pp-33.webp";
import Picture59 from "@/assets/profilePictures/pp-34.webp";
import Picture60 from "@/assets/profilePictures/pp-35.webp";
import Picture61 from "@/assets/profilePictures/pp-36.webp";
import Picture62 from "@/assets/profilePictures/pp-37.webp";

import Slack from "@/assets/icons/Slack.svg";
import Jira from "@/assets/icons/Jira.svg";
import Make from "@/assets/icons/Make.svg";
import Linear from "@/assets/icons/Linear.svg";

export const profilePictures = [
  Picture1,
  Picture2,
  Picture3,
  Picture4,
  Picture5,
  Picture6,
  Picture7,
  Picture8,
  Picture9,
  Picture10,
  Picture11,
  Picture12,
  Picture13,
  Picture14,
  Picture15,
  Picture16,
  Picture17,
  Picture18,
  Picture19,
  Picture20,
  Picture21,
  Picture22,
  Picture23,
  Picture24,
  Picture25,
  Picture51,
  Picture52,
  Picture53,
  Picture54,
  Picture55,
  Picture56,
  Picture57,
  Picture58,
  Picture59,
  Picture60,
  Picture61,
  Picture62,
];

export const integrationsObj: any = {
  slack: {
    desc: "Stay updated on issues and feedback right in Slack. With the Toolbar Slack integration, you’ll get real-time updates in your Slack channels, so your team always knows what’s happening and can fix things faster.",
    icon: Slack,
    name: "slack",
  },
  jira: {
    desc: "Stay updated on issues and feedback right in Jira. With the Toolbar Jira integration, you’ll get real-time updates in your Jira projects, so your team always knows what’s happening and can fix things faster.",
    icon: Jira,
    name: "slack",
  },
  linear: {
    desc: "Stay updated on issues and feedback right in Linear. With the Toolbar Linear integration, you’ll get real-time updates in your Linear projects, so your team always knows what’s happening and can fix things faster.",
    icon: Linear,
    name: "linear",
    soon: true,
  },
  make: {
    desc: "",
    icon: Make,
    name: "make",
    soon: true,
  },
};

export const integrations = [
  {
    name: "slack",
    icon: Slack,
    desc: "Stay updated on issues and feedback right in Slack. With the Toolbar Slack integration, you’ll get real-time updates in your Slack channels, so your team always knows what’s happening and can fix things faster.",
  },
  {
    name: "jira",
    icon: Jira,
    // soon: true,
    desc: "Stay updated on issues and feedback right in Jira. With the Toolbar Jira integration, you’ll get real-time updates in your Slack channels, so your team always knows what’s happening and can fix things faster.",
  },
  {
    name: "linear",
    icon: Linear,
    soon: true,
    desc: "",
  },
  {
    name: "make",
    icon: Make,
    soon: true,
    desc: "",
  },
];

export const timestamps = [1, 7, 14, 30, 60];

// export const scriptTypes = [
//   {
//     label: "Custom",
//     type: "custom",
//   },
//   {
//     label: "Shopify",
//     type: "shopify",
//   },
//   {
//     label: "Framer",
//     type: "framer",
//   },
//   {
//     label: "Webflow",
//     type: "webflow",
//   },
// ];

export const scriptTypes = [
  {
    type: "Custom",
    steps: [
      {
        title: "Step 1: Copy the Toolbar Script",
        desc: "Open the Install Guide pop-up in your Toolbar dashboard and copy your unique Toolbar script.",
      },
      {
        title: "Step 2: Open Your Website’s Codebase",
        desc: "Access the source code of your website using your preferred code editor.",
      },
      {
        title: "Step 3: Locate the <head> Tag",
        desc: "In your project’s main HTML file (usually index.html or similar), find the opening <head> tag.",
      },
      {
        title: "Step 4: Paste Your Toolbar Script",
        desc: "Paste your Toolbar script directly inside the <head> section, before the closing </head> tag.",
      },
      {
        title: "Step 5: Save and Deploy",
        desc: "Save your changes and deploy your website as usual. Toolbar will now be active on your site.",
      },
    ],
  },
  {
    type: "Squarespace",
    steps: [
      {
        title: "Step 1: Copy the Toolbar Script",
        desc: "Open the Install Guide pop-up in your Toolbar dashboard and copy your unique Toolbar script.",
      },
      {
        title: "Step 2: Go to Settings in Squarespace",
        desc: "Log in to your Squarespace account, select the website you want to install Toolbar on, and go to “Settings.”",
      },
      {
        title: "Step 3: Click on “Advanced”",
        desc: "In the settings menu, click on the “Advanced” section.",
      },
      {
        title: "Step 4: Select “Code Injection”",
        desc: "Choose “Code Injection” from the Advanced menu options.",
      },
      {
        title: "Step 5: Paste Your Toolbar Script in the Header",
        desc: "Paste your Toolbar script into the “Header” field under Code Injection.",
      },
      {
        title: "Step 6: Save and Publish",
        desc: "Save your changes. Toolbar will now be active on your Squarespace website.",
      },
    ],
  },
  {
    type: "Shopify",
    steps: [
      {
        title: "Step 1: Copy the Toolbar Script",
        desc: "Open the Install Guide pop-up in your Toolbar dashboard and copy your unique Toolbar script.",
      },
      {
        title: "Step 2: Go to “Themes” in Shopify",
        desc: "In your Shopify admin dashboard, navigate to “Online Store” and select “Themes.”",
      },
      {
        title: "Step 3: Click “Edit Code”",
        desc: "Click on the menu next to your active theme and choose “Edit Code.”",
      },
      {
        title: "Step 4: Find theme.liquid",
        desc: "In the left sidebar, locate and open the “theme.liquid” file.",
      },
      {
        title: "Step 5: Paste Your Toolbar Script in the Header",
        desc: "Find the end of the <header> section and paste your Toolbar script just above it.",
      },
      {
        title: "Step 6: Save and Publish",
        desc: "Save your changes and publish your theme. Toolbar is now active on your Shopify store.",
      },
    ],
  },
  {
    type: "Framer",
    steps: [
      {
        title: "Step 1: Copy the script",
        desc: "Head over to the Install Guide pop-up and snag that script.",
      },
      {
        title: "Step 2: Go to Website Settings in Framer",
        desc: "Log in to your Framer dashboard and select the project you want to install Toolbar on. Click on “Settings.”",
      },
      {
        title: "Step 3: Click “General”",
        desc: "In the settings menu on the left, click on “General.”",
      },
      {
        title: "Step 4: Scroll to “Custom Code”",
        desc: "Scroll down to the “Custom Code” section at the bottom of the page.",
      },
      {
        title: "Step 5: Paste Your Toolbar Script in the Header",
        desc: "Paste your Toolbar script into the header section.",
      },
      {
        title: "Step 6: Save and Publish",
        desc: "Save your changes and publish your project. Toolbar will now be active on your Framer site.",
      },
    ],
  },
  {
    type: "Webflow",
    steps: [
      {
        title: "Step 1: Copy the script",
        desc: "Head over to the Install Guide pop-up and snag that script.",
      },
      {
        title: "Step 2: Go to Website Settings in Webflow",
        desc: "Log in to your Webflow dashboard and select the project you want to install Toolbar on. Click on “Settings” for that project.",
      },
      {
        title: "Step 3: Click on “Custom Code”",
        desc: "In the project settings menu on the left, click on the “Custom Code” tab.",
      },
      {
        title: "Step 4: Paste Your Toolbar Script in the Header",
        desc: "Paste your Toolbar script into the “Head Code” section. Be sure to save your changes.",
      },
      {
        title: "Step 5: Publish Your Website",
        desc: "Click “Publish” to make sure Toolbar is live on your site.",
      },
    ],
  },
  {
    type: "Wordpress",
    steps: [
      {
        title: "Step 1: Copy the script",
        desc: "Head over to the Install Guide pop-up and snag that script.",
      },
      {
        title: "Step 2: Download the “WPCode” Plugin",
        desc: "Go to your WordPress admin dashboard, search for the “WPCode” plugin, and install and activate it.",
      },
      {
        title: "Step 3: Create a New Snippet",
        desc: "In the WordPress dashboard, click on “Code Snippets,” then select “Add New,” and choose “Add Custom Snippet.”",
      },
      {
        title: "Step 4: Paste Your Toolbar Script in the Header",
        desc: "Paste your Toolbar script into the header section of your new custom snippet.",
      },
      {
        title: "Step 5: Save and Publish",
        desc: "Save your changes and make sure the snippet is active. Your Toolbar script will now be live on your WordPress site.",
      },
    ],
  },
];

export const countryFlags = {
  AF: "🇦🇫", // Afghanistan
  AL: "🇦🇱", // Albania
  DZ: "🇩🇿", // Algeria
  AD: "🇦🇩", // Andorra
  AO: "🇦🇴", // Angola
  AG: "🇦🇬", // Antigua & Barbuda
  AR: "🇦🇷", // Argentina
  AM: "🇦🇲", // Armenia
  AU: "🇦🇺", // Australia
  AT: "🇦🇹", // Austria
  AZ: "🇦🇿", // Azerbaijan
  BS: "🇧🇸", // Bahamas
  BH: "🇧🇭", // Bahrain
  BD: "🇧🇩", // Bangladesh
  BB: "🇧🇧", // Barbados
  BY: "🇧🇾", // Belarus
  BE: "🇧🇪", // Belgium
  BZ: "🇧🇿", // Belize
  BJ: "🇧🇯", // Benin
  BT: "🇧🇹", // Bhutan
  BO: "🇧🇴", // Bolivia
  BA: "🇧🇦", // Bosnia & Herzegovina
  BW: "🇧🇼", // Botswana
  BR: "🇧🇷", // Brazil
  BN: "🇧🇳", // Brunei
  BG: "🇧🇬", // Bulgaria
  BF: "🇧🇫", // Burkina Faso
  BI: "🇧🇮", // Burundi
  KH: "🇰🇭", // Cambodia
  CM: "🇨🇲", // Cameroon
  CA: "🇨🇦", // Canada
  CV: "🇨🇻", // Cape Verde
  CF: "🇨🇫", // Central African Republic
  TD: "🇹🇩", // Chad
  CL: "🇨🇱", // Chile
  CN: "🇨🇳", // China
  CO: "🇨🇴", // Colombia
  KM: "🇰🇲", // Comoros
  CG: "🇨🇬", // Congo (Brazzaville)
  CD: "🇨🇩", // Congo (Kinshasa)
  CR: "🇨🇷", // Costa Rica
  HR: "🇭🇷", // Croatia
  CU: "🇨🇺", // Cuba
  CY: "🇨🇾", // Cyprus
  CZ: "🇨🇿", // Czechia
  DK: "🇩🇰", // Denmark
  DJ: "🇩🇯", // Djibouti
  DM: "🇩🇲", // Dominica
  DO: "🇩🇴", // Dominican Republic
  EC: "🇪🇨", // Ecuador
  EG: "🇪🇬", // Egypt
  SV: "🇸🇻", // El Salvador
  GQ: "🇬🇶", // Equatorial Guinea
  ER: "🇪🇷", // Eritrea
  EE: "🇪🇪", // Estonia
  SZ: "🇸🇿", // Eswatini
  ET: "🇪🇹", // Ethiopia
  FJ: "🇫🇯", // Fiji
  FI: "🇫🇮", // Finland
  FR: "🇫🇷", // France
  GA: "🇬🇦", // Gabon
  GM: "🇬🇲", // Gambia
  GE: "🇬🇪", // Georgia
  DE: "🇩🇪", // Germany
  GH: "🇬🇭", // Ghana
  GR: "🇬🇷", // Greece
  GD: "🇬🇩", // Grenada
  GT: "🇬🇹", // Guatemala
  GN: "🇬🇳", // Guinea
  GW: "🇬🇼", // Guinea-Bissau
  GY: "🇬🇾", // Guyana
  HT: "🇭🇹", // Haiti
  HN: "🇭🇳", // Honduras
  HU: "🇭🇺", // Hungary
  IS: "🇮🇸", // Iceland
  IN: "🇮🇳", // India
  ID: "🇮🇩", // Indonesia
  IR: "🇮🇷", // Iran
  IQ: "🇮🇶", // Iraq
  IE: "🇮🇪", // Ireland
  IL: "🇮🇱", // Israel
  IT: "🇮🇹", // Italy
  JM: "🇯🇲", // Jamaica
  JP: "🇯🇵", // Japan
  JO: "🇯🇴", // Jordan
  KZ: "🇰🇿", // Kazakhstan
  KE: "🇰🇪", // Kenya
  KI: "🇰🇮", // Kiribati
  KR: "🇰🇷", // South Korea
  KW: "🇰🇼", // Kuwait
  KG: "🇰🇬", // Kyrgyzstan
  LA: "🇱🇦", // Laos
  LV: "🇱🇻", // Latvia
  LB: "🇱🇧", // Lebanon
  LS: "🇱🇸", // Lesotho
  LR: "🇱🇷", // Liberia
  LY: "🇱🇾", // Libya
  LT: "🇱🇹", // Lithuania
  LU: "🇱🇺", // Luxembourg
  MG: "🇲🇬", // Madagascar
  MW: "🇲🇼", // Malawi
  MY: "🇲🇾", // Malaysia
  MV: "🇲🇻", // Maldives
  ML: "🇲🇱", // Mali
  MT: "🇲🇹", // Malta
  MH: "🇲🇭", // Marshall Islands
  MR: "🇲🇷", // Mauritania
  MU: "🇲🇺", // Mauritius
  MX: "🇲🇽", // Mexico
  FM: "🇫🇲", // Micronesia
  MD: "🇲🇩", // Moldova
  MC: "🇲🇨", // Monaco
  MN: "🇲🇳", // Mongolia
  ME: "🇲🇪", // Montenegro
  MA: "🇲🇦", // Morocco
  MZ: "🇲🇿", // Mozambique
  MM: "🇲🇲", // Myanmar
  NA: "🇳🇦", // Namibia
  NR: "🇳🇷", // Nauru
  NP: "🇳🇵", // Nepal
  NL: "🇳🇱", // Netherlands
  NZ: "🇳🇿", // New Zealand
  NI: "🇳🇮", // Nicaragua
  NE: "🇳🇪", // Niger
  NG: "🇳🇬", // Nigeria
  NO: "🇳🇴", // Norway
  OM: "🇴🇲", // Oman
  PK: "🇵🇰", // Pakistan
  PW: "🇵🇼", // Palau
  PA: "🇵🇦", // Panama
  PG: "🇵🇬", // Papua New Guinea
  PY: "🇵🇾", // Paraguay
  PE: "🇵🇪", // Peru
  PH: "🇵🇭", // Philippines
  PL: "🇵🇱", // Poland
  PT: "🇵🇹", // Portugal
  QA: "🇶🇦", // Qatar
  RO: "🇷🇴", // Romania
  RU: "🇷🇺", // Russia
  RW: "🇷🇼", // Rwanda
  KN: "🇰🇳", // Saint Kitts & Nevis
  LC: "🇱🇨", // Saint Lucia
  VC: "🇻🇨", // Saint Vincent & Grenadines
  WS: "🇼🇸", // Samoa
  SM: "🇸🇲", // San Marino
  ST: "🇸🇹", // São Tomé & Príncipe
  SA: "🇸🇦", // Saudi Arabia
  SN: "🇸🇳", // Senegal
  RS: "🇷🇸", // Serbia
  SC: "🇸🇨", // Seychelles
  SL: "🇸🇱", // Sierra Leone
  SG: "🇸🇬", // Singapore
  SK: "🇸🇰", // Slovakia
  SI: "🇸🇮", // Slovenia
  SB: "🇸🇧", // Solomon Islands
  SO: "🇸🇴", // Somalia
  ZA: "🇿🇦", // South Africa
  ES: "🇪🇸", // Spain
  LK: "🇱🇰", // Sri Lanka
  SD: "🇸🇩", // Sudan
  SR: "🇸🇷", // Suriname
  SE: "🇸🇪", // Sweden
  CH: "🇨🇭", // Switzerland
  SY: "🇸🇾", // Syria
  TW: "🇹🇼", // Taiwan
  TJ: "🇹🇯", // Tajikistan
  TZ: "🇹🇿", // Tanzania
  TH: "🇹🇭", // Thailand
  TL: "🇹🇱", // Timor-Leste
  TG: "🇹🇬", // Togo
  TO: "🇹🇴", // Tonga
  TT: "🇹🇹", // Trinidad & Tobago
  TN: "🇹🇳", // Tunisia
  TR: "🇹🇷", // Türkiye
  TM: "🇹🇲", // Turkmenistan
  TV: "🇹🇻", // Tuvalu
  UG: "🇺🇬", // Uganda
  UA: "🇺🇦", // Ukraine
  AE: "🇦🇪", // United Arab Emirates
  GB: "🇬🇧", // United Kingdom
  US: "🇺🇸", // United States
  UY: "🇺🇾", // Uruguay
  UZ: "🇺🇿", // Uzbekistan
  VU: "🇻🇺", // Vanuatu
  VE: "🇻🇪", // Venezuela
  VN: "🇻🇳", // Vietnam
  YE: "🇾🇪", // Yemen
  ZM: "🇿🇲", // Zambia
  ZW: "🇿🇼", // Zimbabwe
};
